import { useNavigate } from "react-router-dom";

import backIcon from "../../images/botao-voltar.png";
import styles from "./BackIcon.module.css";

const BackIcon = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.back_icon}>
      <button onClick={() => navigate(-1)}>
        <img src={backIcon} alt="Icone de voltar" width={50} height={50} />
      </button>
    </div>
  );
};

export default BackIcon
